$(document).ready(function() {
  $('.MailNotify_button').click(function() {
    console.log("Popup button clicked");
    $('#notifyme-pop-p-container').addClass('show');
    $("body").addClass("no-scroll");
  });

  $('.mailalert-container .close').click(function() {
    $("#notifyme-pop-p-container").removeClass('show');
    $("body").removeClass("no-scroll");
    $('#notifyme-pop-p-container').find('input[type="email"]').val('');
    $('.notify_success').hide();
    $('.notify_failure').hide();
  });
  $(document).click(function(event) {
    if (!$(event.target).closest('.MailNotify_button').length && !$(event.target).closest('.mailalert-container').length) {
      $('#notifyme-pop-p-container').removeClass('show');
      $("body").removeClass("no-scroll");
      $('#notifyme-pop-p-container').find('input[type="email"]').val('');
      $('.notify_success').hide();
      $('.notify_failure').hide();
    }
  });
  
  
  $('.notify_failure').hide();
  $('.notify_success').hide();
  
  function validateEmail(email) {
    var re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  }
  $('#MailNotify').click(function(event) {
     event.preventDefault();

    var email = $('#notify_emails').val();
    var productName = $('#product-name').val();
    var productUrl = $('#product-url').val();
    var productId = $('#product-id').val();
    var productPrice = $("#product-price").val();
    var productImage = $("#product-image").val();
    var productColor = $("#product-color").val();
    var ProductSku = $("#product-sku").val();
    var storeLanguage = $("#store-language").val();
    var customerId = $("#customerid").val();
    var customerName = $("#customername").val();


    console.log('Email to be posted:-', email);
    console.log('Product Name:-', productName);
    console.log('Product Url:-', productUrl);
    console.log('product Id:-', productId);
    console.log('product Price:-', productPrice);
    console.log('product Image:-', productImage);
    console.log('Product Color:-', productColor);
    console.log('Product Sku:-', ProductSku);
    console.log('storeLanguage:-', storeLanguage);
    console.log('customer Id:-', customerId);
    console.log('customer Name:-', customerName);

    
    // Validate the email if necessary

      if (!validateEmail(email)) {
        alert("Please enter a valid email address.");
        return false;
      }
    
    // Example: post the email using AJAX
    $.ajax({
      url: 'https://ps16.store-and-supply.com/shopify_apps/peter-and-may/back_to_stock/import-script/email_alert.php',
      type: 'POST',
      data: { email: email, productName: productName, productUrl: productUrl, productId: productId, productPrice: productPrice, productImage: productImage, productColor: productColor, 
               ProductSku: ProductSku, storeLanguage: storeLanguage, customerId: customerId, customerName: customerName }, // Removed the trailing comma
      success: function(response){
        if (response === "Customer data registered") {
          $('.notify_success').show();
          $('.notify_failure').hide();
        } else if (response === "Already registered this mail") {
          $('.notify_failure').show();
          $('.notify_success').hide();
        } else {
          console.error('Unexpected response:', response);
        }
      },
      
      error: function(xhr, status, error) {
        console.error('Error posting email:', error);
        $('.notify_failure').show();
        $('.notify_success').hide();
      }
    });
  });
});